export default "__VITE_ASSET__K$7IjhjQ__"